import { Routes, Route } from 'react-router-dom';
import { DashboardLayout } from './components/layout/DashboardLayout';
import {
  LoginPage,
  AuthVerifyPage,
  DashboardPage,
  InternalQAQueuePage,
  SiteDetailPage,
  GenerationQueuePage,
  SitesPage,
  OnboardingAnalyticsPage,
  AdminUsersPage,
  ServiceChargesPage,
} from './pages';
import {
  OnboardingStartPage,
  OnboardingWizardPage,
  OnboardingCompletePage,
} from './pages/onboarding';
import { EditorPage } from './editor/EditorPage';

export default function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/auth/verify" element={<AuthVerifyPage />} />
      <Route path="/onboarding-complete" element={<OnboardingCompletePage />} />

      {/* Onboarding routes (no auth required - magic link session) */}
      <Route path="/onboarding/start" element={<OnboardingStartPage />} />
      <Route path="/onboarding/:sessionId" element={<OnboardingWizardPage />} />

      {/* Editor route (full-screen, no dashboard layout) */}
      <Route path="/editor/:websiteId" element={<EditorPage />} />

      {/* Protected routes */}
      <Route element={<DashboardLayout />}>
        <Route path="/" element={<DashboardPage />} />
        <Route path="/sites" element={<SitesPage />} />
        <Route path="/internal-qa" element={<InternalQAQueuePage />} />
        <Route path="/internal-qa/:websiteId" element={<SiteDetailPage />} />
        <Route path="/queue" element={<GenerationQueuePage />} />
        <Route path="/onboarding-analytics" element={<OnboardingAnalyticsPage />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/service-charges" element={<ServiceChargesPage />} />
      </Route>
    </Routes>
  );
}
